import { getErrorMessage } from './getErrorMessage';

export const convertToError = (error: unknown, message?: string) => {
	if (error instanceof Error) {
		return error;
	}

	return new Error(message ?? getErrorMessage(error));
};
